const USER_KEY = 'userData';

const setUserData = (data) => {
  localStorage.setItem(USER_KEY, JSON.stringify(data));
};

const getUserData = () => {
  const user = localStorage.getItem(USER_KEY);
  if (user) return JSON.parse(user);
  return null;
};

const isAuthenticated = () => localStorage.getItem(USER_KEY) !== null;

const clearAuth = () => {
  localStorage.removeItem(USER_KEY);
};

export { setUserData, getUserData, isAuthenticated, clearAuth };
